import axios from 'axios'
import baseData from '@/baseData.js'
const baseUrl = baseData.baseUrl

export default {
    getUserInfo(params) {
        return axios.post(`${baseUrl}/user/getUserInfo`, params)
    },
    removeUser(params) {
        return axios.post(`${baseUrl}/user/removeUser`, params)
    },
    editUserInfo(params) {
        return axios.post(`${baseUrl}/user/editUserInfo`, params)
    },
    updateUserPassword(params) {
        return axios.post(`${baseUrl}/user/updateUserPassword`, params)
    },
}